<template>
  <v-dialog scrollable persistent content-class="custom-dialog" ref="dlgTokenEksternal" v-model="dialog" retain-focus max-width="700">
    <template v-slot:activator="{}"></template>

    <v-card>
      <v-card-title class="primary title white--text">Input Token</v-card-title>
      <v-card-text>
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <m-alert show color="red lighten-1">
                <template>
                  <span class="light-red--text">
                    Bagi peserta yang melakukan pendaftaran mulai tanggal 28 Juni 2021, diwajibkan mengisi token pada form dibawah ini.
                  </span>
                </template></m-alert
              ></v-col
            >
            <v-col cols="4" class="text-center">
              <v-img src="https://cdn.siap.id/s3/simpkb/asset%20img/ayo%20guru%20belajar%20&%20berbagi/GTK-PAUD/popuptoken.png"> </v-img>
            </v-col>
            <v-col cols="8">
              <p
                class="title primary--text clas
              mb-0 pb-0 font-weight-bold"
              >
                TOKEN
              </p>
              <p>Silakan masukan <strong>Token</strong> yang Anda miliki pada kolom dibawah ini untuk mengikuti diklat</p>
              <p class="pb-2">Token didapat dari Sahabat PAUD lain yang tuntas EDP seri PAUDHI</p>

              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-text-field
                  outlined
                  dense
                  autocomplete="false"
                  name="Token"
                  placeholder="Masukkan token disini"
                  label="Token"
                  v-model="token"
                  persistent-hint
                  data-vv-name="token"
                  data-vv-as="Token"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.token')"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <m-button class="mx-1" :small="$vuetify.breakpoint.smAndDown ? true : false" textButton="SIMPAN" icon="" action="inputToken" @inputToken="inputToken()"></m-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      jenis: null,
      items: [],
      edit: false,
      dialog: false,
      resolve: null,
      reject: null,
      idJenis: null,
      kelasObject: {},
      stepData: 1,
      token: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open() {
      this.$validator.reset();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    inputToken() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$infoDlg(`Apakah Anda yakin akan menggunakan Token ini?<br>`, {}, "Persetujuan").then(() => {
            var objToken = {
              token: this.token
            };
            return this.$store
              .dispatch("kelas/setToken", objToken)
              .then(res => {
                this.$store.commit("main/pEnd");
                this.$info("Token berhasil digunakan ");
                this.dialog = false;
                this.edit = false;
                return this.resolve(res);
              })
              .catch(() => {
                this.$store.commit("main/pEnd");
              });
          });
        });
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    }
  }
};
</script>
